import React from "react"

function IconCog({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="cog"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-cog"
      {...props}
    >
      <path
        d="M12.777 2.073c.624 0 1.16.44 1.283 1.052l.26 1.296a7.846 7.846 0 0 1 2.816 1.628l1.254-.424a1.31 1.31 0 0 1 1.554.586l.89 1.542c.312.54.2 1.226-.27 1.638l-.992.873a7.887 7.887 0 0 1 0 3.254l.993.873a1.31 1.31 0 0 1 .27 1.638l-.891 1.542a1.31 1.31 0 0 1-1.554.586l-1.254-.424a7.846 7.846 0 0 1-2.815 1.628l-.26 1.296a1.31 1.31 0 0 1-1.284 1.052h-1.781a1.31 1.31 0 0 1-1.284-1.052l-.26-1.296a7.846 7.846 0 0 1-2.816-1.628l-1.254.424a1.31 1.31 0 0 1-1.553-.586l-.89-1.542a1.31 1.31 0 0 1 .269-1.638l.992-.873a7.887 7.887 0 0 1 0-3.254l-.992-.873a1.31 1.31 0 0 1-.27-1.638l.89-1.542a1.31 1.31 0 0 1 1.554-.586l1.254.424a7.846 7.846 0 0 1 2.816-1.628l.26-1.296a1.31 1.31 0 0 1 1.284-1.052h1.78zm0 1.309h-1.781l-.41 2.046-.728.237A6.529 6.529 0 0 0 7.77 6.8l-.26.222-.57.512-1.979-.669-.89 1.543 1.567 1.377-.158.748a6.578 6.578 0 0 0-.061 2.381l.061.334.158.749-1.567 1.377.89 1.542 1.98-.668.57.511c.593.535 1.28.956 2.023 1.243l.323.114.728.237.41 2.047 1.78-.001.412-2.046.727-.237a6.529 6.529 0 0 0 2.086-1.134l.26-.222.57-.512 1.979.669.89-1.543-1.567-1.377.158-.749a6.578 6.578 0 0 0 .061-2.38l-.061-.335-.158-.748L19.7 8.408l-.89-1.543-1.98.669-.57-.512a6.545 6.545 0 0 0-2.022-1.242l-.323-.114-.727-.237-.411-2.047zm-.89 4.582a3.927 3.927 0 1 1 0 7.854 3.927 3.927 0 0 1 0-7.854zm0 1.309a2.618 2.618 0 1 0 0 5.236 2.618 2.618 0 0 0 0-5.236z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconCog
